// extracted by mini-css-extract-plugin
module.exports = {"vGutter":"8px","title":"CatalogItems_title__BkRtp","item":"CatalogItems_item__3nQ6Y"};